// The device functions' API per app client (W16-W19 of APP-PARITY.md "Detail-Abgleich"): the real one by default, the
// screen gallery and tests hand in their own (fake fetch) with provideDevice().
import type { BrewcoreClient } from '../../core/index.js';
import { DeviceApi } from '../../core/index.js';
import { useMachine } from '../machine-context.js';

const apis = new WeakMap<BrewcoreClient, DeviceApi>();

export function provideDevice(client: BrewcoreClient, api: DeviceApi): void {
  apis.set(client, api);
}

export function useDeviceApi(): DeviceApi {
  const { client } = useMachine();
  let a = apis.get(client);
  if (!a) {
    a = new DeviceApi();
    apis.set(client, a);
  }
  return a;
}
